import dayjs from "dayjs";

export function buildDateRange(start: string, end: string) {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  if (!startDate.isValid() || !endDate.isValid() || endDate.isBefore(startDate, "day")) return [];
  const dates: string[] = [];
  let cursor = startDate;
  while (cursor.isBefore(endDate, "day") || cursor.isSame(endDate, "day")) {
    dates.push(cursor.format("YYYY-MM-DD"));
    cursor = cursor.add(1, "day");
  }
  return dates;
}
